import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { z } from 'zod';
import { zodI18nMap } from 'zod-i18n-map';
import zodFrTranslation from 'zod-i18n-map/locales/fr/zod.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'chronicIllnesses'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.addResourceBundle('fr', 'zod', zodFrTranslation);
i18n.changeLanguage('fr');
z.setErrorMap(zodI18nMap);

export default i18n;

export type TFunctionCommon = TFunction<'common'>;
export type TFunctionChronicIllnesses = TFunction<'chronicIllnesses'>;
